import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./scroolhide.css";

import Adhesives from "../Data/ADHESIVES.json";
import RTV from "../Data/Aircraft Maintenance (RTV).json";
import Roofcoating from "../Data/ROOF COATINGS.json";
import Sealents from "../Data/SEALENTS.json";
import Steelstructures from "../Data/STEEL STRUCTURE.json";

function Searchproductdaynamic() {
  const [searchTerm, setSearchTerm] = useState("");
  const [localProducts, setLocalProducts] = useState([]);
  const [apiProducts, setApiProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  // Load local products
  useEffect(() => {
    setLocalProducts([
      ...Adhesives,
      ...RTV,
      ...Roofcoating,
      ...Sealents,
      ...Steelstructures,
    ]);
  }, []);

  // Fetch API products
  useEffect(() => {
    fetch("https://backend.aktcorp.com/product")
      .then((res) => res.json())
      .then((data) => {
        setApiProducts(Array.isArray(data.data) ? data.data : []);
      })
      .catch((err) => console.error("Error fetching API products:", err));
  }, []);

  useEffect(() => {
    if (searchTerm.trim()) {
      const lowerSearch = searchTerm.toLowerCase();

      const matchedLocal = localProducts.filter((product) =>
        String(product?.title?.[0] || "").toLowerCase().includes(lowerSearch)
      );

      const matchedAPI = apiProducts.filter((product) =>
        String(product?.title?.[0] || "").toLowerCase().includes(lowerSearch)
      );

      setFilteredProducts([
        ...matchedLocal.map((item) => ({ ...item, source: "local" })),
        ...matchedAPI.map((item) => ({ ...item, source: "api" })),
      ]);
    } else {
      setFilteredProducts([]);
    }
  }, [searchTerm, localProducts, apiProducts]);


  // Navigation logic
  const getDivisionLink = (product) => {
    const subcategory = String(product?.subcategory || "").toUpperCase();

    if (subcategory.includes("STEEL STRUCTURE")) return "/division/structural-divisions";
    if (subcategory.includes("SEALENTS") || subcategory.includes("SEALANTS")) return "/division/Selment";
    if (subcategory.includes("ADHESIVES")) return "/division/Adhesives";
    if (subcategory.includes("ROOF COATINGS")) return "/division/Roofcoating";
    if (subcategory.includes("AKT AUTOMOTIVE")) return "/division/akt-car-wash";
    if (subcategory.includes("PRODUCTION")) return "/division/production";
    if (subcategory.includes("TIRE-REINFORCEMENT")) return "/division/tire-reinforcement";

    return "/division/structural-divisions";
  };

  const handleSelectProduct = (product) => {
    if (product.source === "local") {
      navigate(getDivisionLink(product));
    } else if (product.source === "api") {
      navigate(`/product/${product.productId || product.id}`);
    }
    setSearchTerm("");
    setFilteredProducts([]);
    setError("");
  };

  const handleSearch = () => {
    const lowerSearch = searchTerm.toLowerCase();

    const matchedProduct = filteredProducts.find((product) =>
      product.source === "local"
        ? String(product?.title[0] || "").toLowerCase() === lowerSearch
        : String(product?.title || "").toLowerCase() === lowerSearch
    );

    if (matchedProduct) {
      handleSelectProduct(matchedProduct);
    } else {
      setError("This product does not match.");
      setTimeout(() => setError(""), 3000);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const highlightMatch = (text, highlight) => {
    const safeText = String(text || "");
    if (!highlight.trim()) return safeText;
    const regex = new RegExp(`(${highlight})`, "gi");
    return safeText.split(regex).map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="bg-yellow-300 font-bold text-black">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <div className="w-full">
      {/* Search Header and Input */}
      <div className="text-[#0C2340] p- relative">
        <h2 className="text-xl md:text-2xl font-bold">SEARCH OUR PRODUCTS</h2>
        <p className="mt-1 text-sm md:text-base">
          Search through our extensive range of products and quickly find the
          perfect match for your projects.
        </p>

        <div className="mt-3 relative">
          <input
            type="text"
            placeholder="Search Product Name"
            className="w-full p-2 rounded-lg text-black bg-gray-200 focus:outline-none"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-600"
            onClick={handleSearch}
          >
            🔍
          </button>
        </div>
        {error && <p className="text-red-600 font-semibold mt-1">{error}</p>}
      </div>

      {/* Search Results Dropdown */}
      {filteredProducts.length > 0 && (
        <div className="rounded-lg max-h-[150px] overflow-y-auto hide-scrollbar">
          {filteredProducts.map((product, index) => (
            <div
              key={product.productId || index}
              className="p-2 cursor-pointer"
              onClick={() => handleSelectProduct(product)}
            >
              <p className="text-sm font-bold">
                {highlightMatch(product.title[0], searchTerm)}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Searchproductdaynamic;
